import { render, staticRenderFns } from "./PasswordEditComplete.vue?vue&type=template&id=d24e7e50&lang=pug&"
import script from "./PasswordEditComplete.vue?vue&type=script&lang=ts&"
export * from "./PasswordEditComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports